import React from 'react';
import { getTicketTabs, isMultiSessionEvent } from '../../utils/sessionTickets';

/**
 * Navigation par session (style admin : pastilles, actif en #162D3D).
 */
export default function PassSessionTabs({
    event,
    tickets = [],
    activeTab,
    onChange,
    selectedCounts = {},
    className = '',
}) {
    if (!isMultiSessionEvent(event)) return null;

    const tabs = getTicketTabs(event, tickets);
    if (!tabs.length) return null;

    return (
        <div
            className={`flex flex-wrap gap-2 pb-3 mb-3 border-b border-slate-200/80 dark:border-slate-700/60 ${className}`}
            role="tablist"
            aria-label="Jours de l'événement"
        >
            {tabs.map((tab) => {
                const active = tab.id === activeTab;
                const qty = Number(selectedCounts[tab.id]) || 0;
                const timeHint =
                    tab.id !== 'full' && tab.starts_at
                        ? ` · ${tab.starts_at}${tab.ends_at ? `–${tab.ends_at}` : ''}`
                        : '';

                return (
                    <button
                        key={tab.id}
                        type="button"
                        role="tab"
                        aria-selected={active}
                        onClick={() => onChange?.(tab.id)}
                        className={`relative inline-flex flex-wrap items-center gap-x-1.5 gap-y-0.5 px-3.5 py-1.5 rounded-full border text-left text-sm font-semibold transition-colors ${
                            active
                                ? 'bg-[#162D3D] border-[#162D3D] text-white'
                                : 'bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-600 text-[#162D3D] dark:text-slate-100 hover:border-[#162D3D]/40'
                        }`}
                    >
                        <span>{tab.label}</span>
                        {tab.sublabel && (
                            <span
                                className={`text-xs font-medium ${
                                    active ? 'text-white/80' : 'text-slate-500 dark:text-slate-400'
                                }`}
                            >
                                {tab.sublabel}
                                {timeHint}
                            </span>
                        )}
                        {qty > 0 && (
                            <span
                                className={`inline-flex items-center justify-center min-w-[1.15rem] h-[1.15rem] px-1 rounded-full text-[10px] font-bold ${
                                    active ? 'bg-white text-[#162D3D]' : 'bg-[#162D3D] text-white'
                                }`}
                            >
                                {qty}
                            </span>
                        )}
                    </button>
                );
            })}
        </div>
    );
}
